import { CustomerAPI } from 'api'

export const getRevenueMetrics = async (start, end) =>
  CustomerAPI.get(`/salesforce/influence_metrics`, {
    params: { start, end },
  }).then((response) => response.data)
